// Self-hosted fonts (no external CDN — CSP/PWA safe)
import "@fontsource/geist-sans/300.css";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@fontsource/bricolage-grotesque/500.css";
import "@fontsource/bricolage-grotesque/600.css";
import "@fontsource/bricolage-grotesque/700.css";
import "@fontsource/bricolage-grotesque/800.css";
import "@fontsource-variable/jetbrains-mono/wght.css";

import "./index.css";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import App from "./App";
import { AuthProvider } from "./context/authContext/AuthContext";
import { CoinProvider } from "./context/coinContext/CoinContext";
import { FreakProvider } from "./context/freakContext/FreakContext";
import { ToastProvider } from "./components/ui";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CoinProvider>
        <FreakProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </FreakProvider>
      </CoinProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//
// onUpdate: without this, a freshly deployed service worker sits in the
// "waiting" state forever (the app shell is precached, so reloads keep
// serving the old build until every tab is closed). Tell the new worker to
// take over immediately, then reload once so the page and the new precache
// agree — otherwise lazy chunks 404 against the old hashed filenames.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waiting = registration.waiting;
    if (!waiting) return;
    waiting.addEventListener("statechange", (event) => {
      if ((event.target as ServiceWorker).state === "activated") {
        window.location.reload();
      }
    });
    waiting.postMessage({ type: "SKIP_WAITING" });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
